import { SEVERITY_BADGE_MAP, SEVERITY_MAP } from '@/constants/common'
import style from '@/styles/variables/_initiativeStatus.scss'

export const IMPACT = SEVERITY_MAP

export function impactLabel(id) {
  return IMPACT[id].label
}

export const DATE_BADGE_MAP = {
  past: 'badge-past',
  today: 'badge-today',
  future: 'badge-future',
  default: 'badge-future'
}
export const IMPACT_BADGE_MAP = SEVERITY_BADGE_MAP

export const INITIATIVE_EVENT_TYPE = {
  COMMENT: 'comment',
  CREATED: 'created',
  CLOSED: 'closed',
  REOPENED: 'reopened',
  FIELD_CHANGED: 'field_changed',
  AWARD: 'award',
  CUSTOM_FIELD_CHANGED: 'custom_field_changed',
  OWNERSHIP_CHANGED: 'ownership_changed'
}

export const BOARD_GROUP_TYPE = {
  FIELD: 'FIELD',
  CUSTOM_FIELD: 'CUSTOM_FIELD'
}

export const INITIATIVE_FIELDS = {
  IMPACT: {
    id: 'impact',
    label: 'Priority',
    type: BOARD_GROUP_TYPE.FIELD
  },
  OWNER: {
    id: 'owner',
    label: 'Owner',
    type: BOARD_GROUP_TYPE.FIELD
  },
  STATUS: {
    id: 'status',
    label: 'Status',
    type: BOARD_GROUP_TYPE.FIELD
  }
}

export const STATUS = {
  notStarted: {
    label: 'Not Started',
    id: 'not-started',
    icon: 'clock-filled-icon',
    color: style.initiativeStatus_notStarted
  },
  inProgress: {
    label: 'In Progress',
    id: 'on-track',
    icon: 'blue-pie-icon',
    color: style.initiativeStatus_onTrack
  },
  behind: {
    label: 'Behind',
    id: 'behind',
    icon: 'orange-pie-icon',
    color: style.initiativeStatus_behind
  },
  atRisk: {
    label: 'At Risk',
    id: 'at-risk',
    icon: 'red-pie-icon',
    color: style.initiativeStatus_atRisk
  },
  completed: {
    label: 'Done',
    id: 'done',
    icon: 'green-checkmark-icon',
    color: style.initiativeStatus_done
  }
}
export const STATUS_OPTIONS = [
  STATUS.notStarted,
  STATUS.inProgress,
  STATUS.behind,
  STATUS.atRisk,
  STATUS.completed
]

function findStatus(id) {
  return Object.values(STATUS).find(x => x.id === id)
}

export function statusLabel(id) {
  return findStatus(id).label
}

export function statusIcon(id) {
  return findStatus(id).icon
}

export const DEFAULT_IMPACT = IMPACT.low.id
export const DEFAULT_STATUS = STATUS.notStarted.id
export const INITIATIVE_ROW = 'InitiativeRow'
export const TASK_ROW = 'TaskRow'

export const FILTER_OPTIONS = {
  due_date: [
    {
      label: 'Not set',
      id: 'blank'
    }
  ],
  status: STATUS_OPTIONS,
  priority: [SEVERITY_MAP.low, SEVERITY_MAP.medium, SEVERITY_MAP.high],
  effort: [SEVERITY_MAP.low, SEVERITY_MAP.medium, SEVERITY_MAP.high],
  reach: [SEVERITY_MAP.low, SEVERITY_MAP.medium, SEVERITY_MAP.high]
}

export const SHOW_INITIATIVE_ID = {
  any: 'any',
  initiatives: 'initiatives',
  tasks: 'tasks'
}
export const SHOW_INITIATIVES_OPTIONS = [
  { label: 'Only Initiatives', id: SHOW_INITIATIVE_ID.initiatives },
  { label: 'Only Tasks', id: SHOW_INITIATIVE_ID.tasks },
  { label: 'Initiatives and Tasks', id: SHOW_INITIATIVE_ID.any }
]
export const BOARD_VIEW = 'board'
export const LIST_VIEW = 'list'
export const INITIATIVE_VIEWS_TYPES = [
  { label: 'Board', id: BOARD_VIEW },
  { label: 'List', id: LIST_VIEW }
]
export const GROUP_BY_NONE_ID = 'none'
export const GROUP_BY_SECTION_ID = 'section'
export const DEFAULT_GROUP_BY = {
  [LIST_VIEW]: 'none',
  [BOARD_VIEW]: 'status'
}
export const PROJECT_DEFAULT_GROUP_BY = {
  [LIST_VIEW]: GROUP_BY_SECTION_ID,
  [BOARD_VIEW]: 'status'
}
const DATE_FIELD_WIDTH = 115
export const CUSTOM_FIELD_CELL_WIDTH = 100
export const CUSTOM_FIELD_TEXT_CELL_WIDTH = 330
export const CUSTOM_FIELD_DATE_CELL_WIDTH = DATE_FIELD_WIDTH

export const INITIATIVE_STANDARD_FIELD_NAME = {
  TITLE: 'title',
  CREATED_AT: 'created_at',
  UPDATED_AT: 'updated_at',
  DUE_DATE: 'due_date',
  CLOSED_ON: 'closed_on',
  STATUS: 'status',
  PRIORITY: 'priority',
  OWNERS: 'owners'
}

export const InitiativeFieldType = {
  CUSTOM_FIELD: 'CUSTOM_FIELD',
  COMPUTED_FIELD: 'COMPUTED_FIELD',
  STANDARD_FIELD: 'STANDARD_FIELD'
}

export const INITIATIVE_MANDATORY_FIELD = INITIATIVE_STANDARD_FIELD_NAME.TITLE

export const INITIATIVE_STANDARD_FIELDS = [
  {
    name: INITIATIVE_STANDARD_FIELD_NAME.TITLE,
    title: 'Title',
    fieldType: InitiativeFieldType.STANDARD_FIELD
  },
  {
    name: INITIATIVE_STANDARD_FIELD_NAME.DUE_DATE,
    title: 'Due on',
    fieldType: InitiativeFieldType.STANDARD_FIELD,
    width: DATE_FIELD_WIDTH
  },
  {
    name: INITIATIVE_STANDARD_FIELD_NAME.STATUS,
    title: 'Status',
    fieldType: InitiativeFieldType.STANDARD_FIELD,
    width: 72
  },
  {
    name: INITIATIVE_STANDARD_FIELD_NAME.PRIORITY,
    title: 'Priority',
    fieldType: InitiativeFieldType.STANDARD_FIELD,
    width: 79
  },
  {
    name: INITIATIVE_STANDARD_FIELD_NAME.OWNERS,
    title: 'Owners',
    fieldType: InitiativeFieldType.STANDARD_FIELD,
    width: 77
  }
]

export const SortDirection = {
  ASCENDING: 'ascending',
  DESCENDING: 'descending'
}

/**
 * These are the fields whose value is computed at frontend(FE).
 * Values for these fields are derived from initiative existing fields
 * @type {{DAYS_SINCE_LAST_UPDATE: string, AGE: string}}
 */
export const INITIATIVE_FE_COMPUTED_FIELD_NAME = {
  AGE: 'created_at',
  DAYS_SINCE_LAST_UPDATE: 'updated_at',
  GOAL: 'goal_id',
  KEY_RESULT: 'key_result_id',
  TEAM: 'team',
  PROJECT: 'project_id'
}
export const INITIATIVE_BE_COMPUTED_FIELD_NAME = {
  DUE_DATE_COUNT: 'due_date_count',
  CLOSED_BY_ID: 'closed_by_id',
  STATUS_DONE_BY_ID: 'status_done_by_id',
  CREATOR_ID: 'creator_id',
  LAST_COMMENT: 'last_comment'
}
export const ALPHABETICAL_SORT_OPTIONS = [
  { title: 'A → Z', direction: SortDirection.ASCENDING },
  { title: 'Z → A', direction: SortDirection.DESCENDING }
]
export const NUMERIC_SORT_OPTIONS = [
  { title: '0 → 9', direction: SortDirection.ASCENDING },
  { title: '9 → 0', direction: SortDirection.DESCENDING }
]
export const DATE_SORT_OPTIONS = [
  { title: 'Earliest First', direction: SortDirection.ASCENDING },
  { title: 'Latest First', direction: SortDirection.DESCENDING }
]
export const INITIATIVE_COMPUTED_FIELD_NAME = {
  ...INITIATIVE_BE_COMPUTED_FIELD_NAME,
  ...INITIATIVE_FE_COMPUTED_FIELD_NAME
}

export const COMPUTED_FIELD_SORT_OPTIONS = {
  [INITIATIVE_COMPUTED_FIELD_NAME.DUE_DATE_COUNT]: NUMERIC_SORT_OPTIONS,
  [INITIATIVE_COMPUTED_FIELD_NAME.CLOSED_BY_ID]: ALPHABETICAL_SORT_OPTIONS,
  [INITIATIVE_COMPUTED_FIELD_NAME.STATUS_DONE_BY_ID]: ALPHABETICAL_SORT_OPTIONS,
  [INITIATIVE_COMPUTED_FIELD_NAME.CREATOR_ID]: ALPHABETICAL_SORT_OPTIONS,
  [INITIATIVE_COMPUTED_FIELD_NAME.AGE]: DATE_SORT_OPTIONS,
  [INITIATIVE_COMPUTED_FIELD_NAME.DAYS_SINCE_LAST_UPDATE]: DATE_SORT_OPTIONS,
  [INITIATIVE_COMPUTED_FIELD_NAME.GOAL]: ALPHABETICAL_SORT_OPTIONS,
  [INITIATIVE_COMPUTED_FIELD_NAME.KEY_RESULT]: ALPHABETICAL_SORT_OPTIONS,
  [INITIATIVE_COMPUTED_FIELD_NAME.PROJECT]: ALPHABETICAL_SORT_OPTIONS,
  [INITIATIVE_COMPUTED_FIELD_NAME.TEAM]: ALPHABETICAL_SORT_OPTIONS,
  [INITIATIVE_COMPUTED_FIELD_NAME.LAST_COMMENT]: DATE_SORT_OPTIONS
}

export const TEAM_LEVEL_INITIATIVE_COMPUTED_FIELDS = [
  {
    name: INITIATIVE_COMPUTED_FIELD_NAME.KEY_RESULT,
    title: 'Key result',
    width: 330,
    fieldType: InitiativeFieldType.COMPUTED_FIELD,
    align: 'left'
  },
  {
    name: INITIATIVE_COMPUTED_FIELD_NAME.GOAL,
    title: 'Goal',
    width: 330,
    fieldType: InitiativeFieldType.COMPUTED_FIELD,
    align: 'left'
  },
  {
    name: INITIATIVE_COMPUTED_FIELD_NAME.TEAM,
    title: 'Team',
    width: 130,
    fieldType: InitiativeFieldType.COMPUTED_FIELD
  }
]

export const PROJECT_LEVEL_INITIATIVE_FIELDS = [
  {
    name: INITIATIVE_COMPUTED_FIELD_NAME.PROJECT,
    title: 'Project',
    width: 200,
    fieldType: InitiativeFieldType.COMPUTED_FIELD,
    align: 'left'
  }
]

export const INITIATIVE_COMPUTED_FIELDS = [
  {
    name: INITIATIVE_COMPUTED_FIELD_NAME.CLOSED_BY_ID,
    title: 'Closed by',
    width: CUSTOM_FIELD_CELL_WIDTH,
    fieldType: InitiativeFieldType.COMPUTED_FIELD
  },
  {
    name: INITIATIVE_COMPUTED_FIELD_NAME.STATUS_DONE_BY_ID,
    title: 'Completed by',
    width: CUSTOM_FIELD_CELL_WIDTH,
    fieldType: InitiativeFieldType.COMPUTED_FIELD
  },
  {
    name: INITIATIVE_COMPUTED_FIELD_NAME.CREATOR_ID,
    title: 'Created by',
    width: CUSTOM_FIELD_CELL_WIDTH,
    fieldType: InitiativeFieldType.COMPUTED_FIELD
  },
  {
    name: INITIATIVE_COMPUTED_FIELD_NAME.DAYS_SINCE_LAST_UPDATE,
    title: 'Days since update',
    width: CUSTOM_FIELD_CELL_WIDTH,
    fieldType: InitiativeFieldType.COMPUTED_FIELD
  },
  {
    name: INITIATIVE_COMPUTED_FIELD_NAME.DUE_DATE_COUNT,
    title: 'Due date updated',
    width: CUSTOM_FIELD_CELL_WIDTH,
    fieldType: InitiativeFieldType.COMPUTED_FIELD
  },
  {
    name: INITIATIVE_COMPUTED_FIELD_NAME.AGE,
    title: 'Initiative age',
    width: CUSTOM_FIELD_CELL_WIDTH,
    fieldType: InitiativeFieldType.COMPUTED_FIELD
  },
  {
    name: INITIATIVE_COMPUTED_FIELD_NAME.LAST_COMMENT,
    title: 'Initiative Comment',
    width: 330,
    fieldType: InitiativeFieldType.COMPUTED_FIELD,
    align: 'left'
  },
  ...TEAM_LEVEL_INITIATIVE_COMPUTED_FIELDS,
  ...PROJECT_LEVEL_INITIATIVE_FIELDS
]
export const USER_TYPE_COMPUTED_FIELDS = [
  INITIATIVE_COMPUTED_FIELD_NAME.STATUS_DONE_BY_ID,
  INITIATIVE_COMPUTED_FIELD_NAME.CLOSED_BY_ID,
  INITIATIVE_COMPUTED_FIELD_NAME.CREATOR_ID
]
export const SYSTEM_FIELDS = [...INITIATIVE_STANDARD_FIELDS, ...INITIATIVE_COMPUTED_FIELDS]

export const FILTER_OP_SEPARATOR = '~'

export const CF_PREFIX = 'cf_'

export const VIEW_QUERY_PARAM = 'view'
